import { ActionIcon, Group, Menu, Pagination, Table } from "@mantine/core";
import * as C from "../../../../../../ui/common/CommonStyles";
import { useSearchFilters } from "../../../../../../../shared/hook/useSearchFilter";
import { handleChangeLocaleTime } from "../../../../../../../shared/utils/time";
import {
  getNoticeType,
  getSolution,
} from "../../../../../../../shared/constants/commonCode";
import {
  IconDotsVertical,
  IconPencilMinus,
  IconTrash,
} from "@tabler/icons-react";
import { PopupItem } from "../types";
import { useNavigate } from "react-router-dom";
import { usePopupList } from "../hooks/usePopupList";
import { useDeletePopup } from "../hooks/useDeletePopup";
import { queryClient } from "../../../../../../../shared/queryClient";
import { handleError } from "../../../../../../ui/err/handleError";
import { AxiosError } from "axios";
import { showSuccessNotification } from "../../../../../../ui/notification";
import Swal from "sweetalert2";

const tableHead = [
  "번호",
  "솔루션",
  "팝업 유형",
  "제목",
  "노출 기간",
  "노출 상태",
  "등록일자",
  "작성자",
  "수정일자",
  "관리",
];

export default function PopupTable() {
  const navigate = useNavigate();
  const initSearchType = "title";

  const {
    page,
    size,
    solutionFilter,
    noticeTypeFilter,
    searchWord,
    updateFilters,
  } = useSearchFilters({
    initType: initSearchType,
  });

  const { deletePopup } = useDeletePopup();

  const { popupList } = usePopupList({
    queryKey: [
      "getPopupList",
      page,
      solutionFilter,
      noticeTypeFilter,
      searchWord,
    ],
    payload: {
      page: Number(page),
      size: Number(size),
      search: {
        title: searchWord || "",
      },
      filter: {
        solutionCd: solutionFilter === "all" ? "" : solutionFilter,
        noticeCd: noticeTypeFilter === "all" ? "" : noticeTypeFilter,
      },
    },
  });

  const onDeletePopup = (id: number) => {
    Swal.fire({
      title: "삭제 전 확인",
      text: "팝업을 삭제하시겠습니까?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "취소",
      confirmButtonText: "삭제",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePopup(id.toString(), {
          onSuccess: () => {
            queryClient.invalidateQueries(["getPopupList"]);
            showSuccessNotification("삭제 되었습니다.");
          },
          onError: (error: unknown) => {
            if (error instanceof AxiosError) {
              handleError(error);
            }
          },
        });
      }
    });
  };

  return (
    <>
      <C.TableWrap>
        <Table.ScrollContainer minWidth={1200}>
          <Table withTableBorder>
            <Table.Thead>
              <Table.Tr>
                {tableHead.map((head) => (
                  <Table.Th key={head}>{head}</Table.Th>
                ))}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {popupList.result.length > 0 ? (
                popupList.result.map((item: PopupItem, index: number) => (
                  <Table.Tr key={item.popupId}>
                    <Table.Td>
                      {Number(page) === 1
                        ? index + 1
                        : (Number(page) - 1) * 10 + index + 1}
                    </Table.Td>
                    <Table.Td>{getSolution(item.solutionCd)}</Table.Td>
                    <Table.Td>{getNoticeType(item.noticeCd)}</Table.Td>
                    <Table.Td>{item.title}</Table.Td>
                    <Table.Td>
                      {handleChangeLocaleTime(item.startDate)?.substring(0, 10)}{" "}
                      ~ {handleChangeLocaleTime(item.endDate)?.substring(0, 10)}
                    </Table.Td>
                    <Table.Td>{item.showYn ? "노출" : "미노출"}</Table.Td>
                    <Table.Td>{handleChangeLocaleTime(item.regDate)}</Table.Td>
                    <Table.Td>{item.modUserName}</Table.Td>
                    <Table.Td>{handleChangeLocaleTime(item.modDate)}</Table.Td>
                    <Table.Td>
                      <Menu>
                        <Menu.Target>
                          <ActionIcon variant="transparent">
                            <IconDotsVertical size={16} />
                          </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Menu.Item
                            leftSection={<IconPencilMinus size={16} />}
                            onClick={() =>
                              navigate(
                                `/admin/edgecross/notice/popup/register/${item.popupId}`
                              )
                            }
                          >
                            수정
                          </Menu.Item>
                          <Menu.Item
                            leftSection={<IconTrash size={16} />}
                            onClick={() => onDeletePopup(item.popupId)}
                          >
                            삭제
                          </Menu.Item>
                        </Menu.Dropdown>
                      </Menu>
                    </Table.Td>
                  </Table.Tr>
                ))
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={tableHead.length}>
                    조회된 결과가 없습니다.
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </C.TableWrap>
      <Group justify="center" mt="md">
        <Pagination
          total={Math.ceil(popupList.count / Number(size))}
          value={Number(page)}
          onChange={(value) => {
            updateFilters({
              page: value.toString(),
            });
          }}
        />
      </Group>
    </>
  );
}
